import SingleCustomVoucher from 'components/shared/SingleCustomVoucher'
import { FormattedMessage } from 'react-intl'
import Box from 'components/shared/Box'
import { useSingleVoucher } from './useSingleVoucher'
import { VoucherType } from 'store/api-slice/types'

interface SingleVoucherProps {
    voucherType: VoucherType
    voucherName: string
    cardPerson?: string
    description?: string | string[]
    valuePrice?: string | number
    cardType?: string
    testIdPrefix?: string
    onClick?: () => void
}

export const SingleVoucher = ({
    voucherName,
    voucherType,
    valuePrice,
    cardPerson,
    cardType,
    description,
    onClick,
    testIdPrefix,
}: SingleVoucherProps) => {
    const { getButtonText, vouchersDetails } = useSingleVoucher({
        voucherType,
    })

    return (
        <SingleCustomVoucher>
            <Box
                direction="row"
                align="center"
                justify="space-between"
                isFullWidth
                mb={[16, 0]}
            >
                <SingleCustomVoucher.Heading voucherName={voucherName} />
                {onClick && (
                    <SingleCustomVoucher.Button
                        onClick={onClick}
                        testIdPrefix={testIdPrefix}
                    >
                        {getButtonText()}
                    </SingleCustomVoucher.Button>
                )}
            </Box>
            {voucherType && (
                <SingleCustomVoucher.Row value={vouchersDetails[voucherType]}>
                    <FormattedMessage
                        id="vouchers.summary.voucher_type"
                        defaultMessage="Typ vouchera"
                    />
                </SingleCustomVoucher.Row>
            )}
            {!!cardPerson && (
                <SingleCustomVoucher.Row value={cardPerson}>
                    <FormattedMessage
                        id="vouchers.summary.card_type"
                        defaultMessage="Typ karty"
                    />
                </SingleCustomVoucher.Row>
            )}
            {!!cardType && (
                <SingleCustomVoucher.Row value={cardType}>
                    <FormattedMessage
                        id="vouchers.summary.card_species"
                        defaultMessage="Rodzaj karty"
                    />
                </SingleCustomVoucher.Row>
            )}
            {!!valuePrice && (
                <SingleCustomVoucher.Row value={valuePrice.toString()}>
                    <FormattedMessage
                        id="vouchers.summary.price"
                        defaultMessage="Kwota"
                    />
                </SingleCustomVoucher.Row>
            )}
            {!!description && (
                <SingleCustomVoucher.Row value={description} isBorder={false}>
                    <FormattedMessage
                        id="vouchers.summary.description"
                        defaultMessage="Tekst na voucherze"
                    />
                </SingleCustomVoucher.Row>
            )}
        </SingleCustomVoucher>
    )
}

export const SingleCustomAmountVoucher = (
    props: Pick<
        SingleVoucherProps,
        | 'valuePrice'
        | 'description'
        | 'voucherName'
        | 'onClick'
        | 'testIdPrefix'
    >
) => <SingleVoucher voucherType="amount" {...props} />

export const SingleCustomCardVoucher = (
    props: Pick<
        SingleVoucherProps,
        | 'cardPerson'
        | 'description'
        | 'cardType'
        | 'voucherName'
        | 'onClick'
        | 'testIdPrefix'
    >
) => <SingleVoucher voucherType="product" {...props} />
